import { createSlice } from "@reduxjs/toolkit";

const initialState =  {
      enteredWord1: "",
      enteredWord2: "",
      enteredWord3: "",
      enteredWord4: "",
      enteredWord5: "",
      enteredWord6: "",
    };

const enteredWordSlice = createSlice({
  name: "enteredWordSlice",
  initialState,
  reducers: {
    setEnteredWord1: (state, action) => {
      state.enteredWord1 = action.payload?.join("");
      return state;
    },
    setEnteredWord2: (state, action) => {
      state.enteredWord2 = action.payload?.join("");
      return state;
    },
    setEnteredWord3: (state, action) => {
      state.enteredWord3 = action.payload?.join("");
      return state;
    },
    setEnteredWord4: (state, action) => {
      state.enteredWord4 = action.payload?.join("");
      return state;
    },
    setEnteredWord5: (state, action) => {
      state.enteredWord5 = action.payload?.join("");
      return state;
    },
    setEnteredWord6: (state, action) => {
      state.enteredWord6 = action.payload?.join("");
      return state;
    },
    resetEnteredWords:(state,action)=>{
      state.enteredWord1="";
      state.enteredWord2="";
      state.enteredWord3="";
      state.enteredWord4="";
      state.enteredWord5="";
      state.enteredWord6="";
      return state;
    }
  },
});
export const {
  setEnteredWord1,
  setEnteredWord2,
  setEnteredWord3,
  setEnteredWord4,
  setEnteredWord5,
  setEnteredWord6,
  resetEnteredWords
} = enteredWordSlice.actions;
export default enteredWordSlice;
